import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getGuestData = createSelector(membersState, (members) => members.guestData);
